import { Head } from '@unhead/react';
import React from 'react';

interface SEOPropTypes {
  name?: string;
  title?: string;
  titleTemplate?: string;
  metaTitle?: string;
  description?: string;
  locale?: string;
  url?: string;
  isArticle?: boolean;
  image?: {
    url?: string;
    width?: number;
    height?: number;
    alt?: string;
  };
  twitter?: {
    name?: string;
    image?: string;
    card?: string;
  };
}

const SEO = ({
  name = 'Piczel.tv',
  title,
  titleTemplate = '%s - Piczel.tv',
  metaTitle,
  description = 'An art streaming and gallery service with free multistreaming and no ads.',
  locale = 'en_US',
  url,
  isArticle = false,
  image: providedImage,
  twitter: providedTwitter,
}: SEOPropTypes) => {
  const defaultImage = {
    url: 'https://piczel.tv/img/piczel_tv_full.png',
    width: 1708,
    height: 1311,
    alt: undefined,
  };

  const defaultTwitter = {
    name: '@piczeltv',
    image: providedImage?.url ?? 'https://piczel.tv/img/piczel.jpg',
    card: 'summary_large_image',
  };

  // I also found this image in source: https://piczel.tv/share.png

  const image = {
    ...defaultImage,
    ...providedImage,
  };

  const twitter = {
    ...defaultTwitter,
    ...providedTwitter,
  };

  const formattedTitle = title ? titleTemplate.replace('%s', title) : name;

  return (
    <Head>
      <title>{formattedTitle}</title>
      <meta name="description" content={description} />
      <meta name="image" content={image.url} />

      <meta property="og:site_name" content={name} />
      <meta property="og:locale" content={locale} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={isArticle ? 'article' : 'website'} />
      <meta property="og:title" content={metaTitle ?? formattedTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image.url} />
      <meta property="og:image:width" content={String(image.width)} />
      <meta property="og:image:height" content={String(image.height)} />
      <meta property="og:image:alt" content={formattedTitle} />

      <meta name="twitter:creator" content={twitter.name} />
      <meta name="twitter:card" content={twitter.card} />
      <meta name="twitter:title" content={metaTitle ?? formattedTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={twitter.image ?? image.url} />
      <meta name="twitter:image:alt" content={image.alt ?? description} />
    </Head>
  );
};

export default SEO;
